import { Button } from '@digdir/designsystemet-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { queryClient, queryKeys } from '../../../../../utils/react-query';
import { useArchiveAndCloneRegistration } from '../../../../../components/enovaApplicationList/components/useArchiveAndCloneRegistration';

interface Props {
  energiplanId?: string;
  registrationId?: string;
}

export const ArchiveRegistrationButton: FC<Props> = ({ energiplanId, registrationId }) => {
  const { t } = useTranslation('', { keyPrefix: 'screens.energiplan.components.tiltak' });
  const { archiveRegistration, isLoading } = useArchiveAndCloneRegistration();

  const onArchiveRegistration = () => {
    if (!energiplanId || !registrationId) {
      return;
    }

    archiveRegistration(
      {
        registrationId,
        energiplanId
      },
      {
        onSuccess: () => queryClient.invalidateQueries([queryKeys.energyAnalysisList, ''])
      }
    );
  };
  return (
    <Button loading={isLoading} variant="secondary" onClick={onArchiveRegistration}>
      {t('changeButton')}
    </Button>
  );
};
